import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
// import overlayImage from '../../assets/Spinner.gif';
// import { SpringSpinner } from 'react-epic-spinners';

const styles = theme => ({
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  overlayImage: {
    // width: theme.spacing.unit * 20,
    // height: theme.spacing.unit * 20,
    // position: 'absolute',
    // top: '50%',
    // left: ' 50%',
    // transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    top: '8%',
    left: '8%',
    height: '100px !important',
    width: '100px !important',
    position: 'absolute',
    // transform: translate(-50 %, -50 %);
    // borderRadius: 50%;
    margin: 'auto',
  },
  imageContainer: {
    // width: theme.spacing.unit * 15,
    // height: theme.spacing.unit * 15,
    position: 'absolute',
    top: '50%',
    left: ' 50%',
    backgroundColor: theme.palette.common.white,
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
  },
  progress: {
    margin: theme.spacing(2),
  },
});

const Spinner = props => {
  const { classes } = props;

  const content = props.isLoading ? (
    <div className={classes.overlay}>
      <div className={classes.imageContainer}>
        {/* <img src={overlayImage} alt="Avatar" className={classes.overlayImage} /> */}
        {/* <SpringSpinner className={classes.overlayImage} size={80} color="blue" /> */}
        <CircularProgress className={classes.overlayImage} />
      </div>
    </div>
  ) : null;
  return content;
};

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Spinner);
